import {Stack} from '@mui/material';
import CreateGameButton from './CreateGameButton';
import JoinGameButton from './JoinGameButton';
import PlayerNameInput from '../PlayerNameInput';

const MenuButtons = () => {
    return (
        <Stack
            spacing={{ xs: 2.5, sm: 4 }}
            sx={{
                width: '100%',
                height: '100%',
                alignItems: { xs: 'center', md: 'start' },
                justifyContent: 'center',
            }}
        >
            <PlayerNameInput />
            <CreateGameButton/>
            <JoinGameButton />
        </Stack>
    );
};

export default MenuButtons;
